import styled from '@emotion/styled';
import css from '@styled-system/css';

import { BaseFlex } from '../layouts/Flex/Flex';

export const getColorType = ({ disabled, focus, invalid }) => {
  let type = 'default';
  if (disabled) {
    type = 'disabled';
  } else if (invalid) {
    type = 'negative';
  } else if (focus) {
    type = 'branded';
  }
  return type;
};

export const InputContainer = styled(BaseFlex)((props) => {
  const type = getColorType(props);
  return css({
    display: 'flex',
    position: 'relative',
    width: '100%',
    px: '2x_small',
    fontFamily: 'body',
    fontSize: 'input.text',
    fontWeight: 'normal',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRadius: 1,
    borderColor: `input.${type}.color`,
    backgroundColor: `input.${type}.bg`,
    color: `input.${type}.text`,
  });
});
